<template>
  <div class="MainPage">
    <TheHeader v-if="shouldShowHeader"/>
    <router-view :key="$route.fullPath"></router-view>
    <TheFooter v-if="shouldShowFooter"/>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue';
import TheFooter from '@/components/TheFooter.vue';
import {mapState} from "vuex";

export default {
  name: 'MainPage',
  components: {
    TheHeader,
    TheFooter
  },
  computed: {
    ...mapState(["isMobile", "visibleHeight"]),
    shouldShowHeader() {
      // 默认显示header，除非显式设置为false
      return this.$route.meta?.showHeader !== false;
    },
    shouldShowFooter() {
      // 默认显示footer，除非显式设置为false
      return this.$route.meta?.showFooter !== false;
    }
  }
}
</script>
